import { createContext, useContext } from "react";
import type { Familiarity } from "@itspip/shared";

export type Role = "employee" | "supervisor" | "admin";

export interface CurrentUser {
  id: string;
  name: string;
  email: string;
  role: Role;
  teamId: string;
  departmentHead: boolean;
  familiarity: Familiarity;
}

interface CurrentUserContextValue {
  currentUser: CurrentUser | null;
  isLoading: boolean;
}

export const CurrentUserContext = createContext<CurrentUserContextValue>({
  currentUser: null,
  isLoading: true,
});

export function useCurrentUser() {
  return useContext(CurrentUserContext);
}

export function isAdmin(role: Role | undefined): boolean {
  return role === "admin";
}

export function isSupervisorOrAbove(role: Role | undefined): boolean {
  return role === "supervisor" || role === "admin";
}
